import { render, staticRenderFns } from "./TwoColumnsContainer.vue?vue&type=template&id=1fb2e974&scoped=true&"
import script from "./TwoColumnsContainer.vue?vue&type=script&lang=ts&"
export * from "./TwoColumnsContainer.vue?vue&type=script&lang=ts&"
import style0 from "./TwoColumnsContainer.vue?vue&type=style&index=0&id=1fb2e974&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb2e974",
  null
  
)

export default component.exports